import * as React from 'react';
import { createSvgIcon } from '@mui/material';
var Export = createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  version: "1.1"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M5,12 L5,19 L19,19 L19,12 L21,12 L21,19 L20.9945168,19.1491916 C20.9182025,20.1836033 20.0547727,21 19,21 L19,21 L5,21 L4.85080841,20.9945109 C3.81639669,20.9181157 3,20.0538182 3,19 L3,19 L3,12 L5,12 Z M12,3 L17,7.81481481 L15.59,9.17259259 L13,6.68814815 L13,16 L11,16 L11,6.68814815 L8.41,9.17259259 L7,7.81481481 L12,3 Z",
  id: "export-path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "export-Icons",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "export-All_Icons",
  transform: "translate(-598.000000, -220.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "export-ic_export",
  transform: "translate(595.000000, 217.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "export-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#export-path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero",
  xlinkHref: "#export-path-1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  mask: "url(#export-mask-2)",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("g", {
  id: "export-Colors/Action",
  mask: "url(#export-mask-2)",
  fill: "#176DC2",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-13.000000, -13.000000)",
  id: "export-Colors/Your_color_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L50,0 L50,50 L0,50 L0,0 Z"
}))))))), 'Export');
export { Export };